
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 24 24","fill":"currentColor","stroke":"currentColor"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9 19.188a1.5 1.5 0 0 1-2.121 0L1.5 13.81a1.5 1.5 0 0 1 0-2.122L12 1.188a1.5 1.5 0 0 1 1.061-.439h5.378a1.5 1.5 0 0 1 1.5 1.5v5.379a1.5 1.5 0 0 1-.439 1.06m-3.311-4.564h0","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}}),_c('path',{attrs:{"d":"M16.189 4.124a.375.375 0 1 0 .375.375.375.375 0 0 0-.375-.375m-5.25 13.125a6 6 0 1 0 12 0 6 6 0 1 0-12 0Zm6-2.25v4.5m-2.25-2.25h4.5","fill":"none","stroke-linecap":"round","stroke-linejoin":"round","stroke-width":"1.5"}})])
          )
        }
      }
    